'use strict';

var appTypes = require('../../types/appTypes');
var _ = require('underscore');
var interactiveType = require('../../interactive/InteractiveTypes');

module.exports = {
  parseComInteractive: function (props) {
    var i = 0;
    var links = props.links.link;
    var entries ;
    var result = [];
    var externalURL = props.externalURL;
    var l = 0;
    var d;
    if(props.interactiveData){
      entries = props.interactiveData.entry;
    }
    if(links) {
      l = links.length;
      for (i; i < l; i++) {
        d = {};
        if (this.isValidLink(links[i])) {
          d.link = links[i];
        }
        if(entries) {
          if (this.isValidEntry(entries[i])) {
            d.entry = entries[i];
          }
        }
        if (externalURL) {
          d.externalURL = externalURL;
        }
        result.push(d);
      }
    }
    return result;
  },

  isValidLink : function(link){
    if(link && link.targetPageID && link.linkType === appTypes.PageLinkType.PAGE_LINK){
      return true;
    }
    return false;
  },

  isValidEntry : function(entry){
    if(entry && entry.events && entry.events.event && entry.events.event.length){
      return true;
    }
    return false;
  },

  isValidExternalURL : function(url){
    return !_.isEmpty(url);
  },

  isCanFocus : function(props){
    var d = this.parseComInteractive(props);
    var valid = false;
    var itm;
    if(d && d.length){
      if(d.length > 1){
        return true;
      }else{
        itm = d[0];
      }
      valid = itm.link !== undefined || itm.entry !== undefined || itm.externalURL !== undefined;
    }
    if(!valid){
      valid = ['ContentPanel','ScrollView','ScrollArea','Panel'].indexOf(props.controlTypeID) !== -1;
    }
    return valid;
  },

  hasLongPressByEntry : function(entry){
    var r = false;
    var i;
    var event;
    if(entry && entry.events && entry.events.event){
      for (i = 0; i < entry.events.event.length; i++) {
        event = entry.events.event[i];
        if (event.eventType === interactiveType.InteractiveTypes.EventType.LONG_PRESS){
          r = true;
          break;
        }
      }
    }
    return r;
  },

  hasLongPressEvents: function (interactive,index) {
    var r = false;
    var entry;
    if (interactive) {
      entry = interactive.entry[index];
      return this.hasLongPressByEntry(entry);
    }
    return r;
  }
};


// WEBPACK FOOTER //
// ./src/views/common/LinkHelper.js